import { VblGameData } from "./ticker";

export const samsScopes = ["vbl", "dvv", "bvv"] as const;
export type SamsScope = (typeof samsScopes)[number];

export interface SamsVbl {
  matchDays: MatchDay[];
  matchSeries: { [key in string]: MatchSeries };
  matchStates: { [key in string]: VblGameData };
}

interface MatchDay {
  matches: MatchDayMatch[];
}

interface MatchDayMatch {
  id: string;
  teamDescription1: string;
  team1: string;
  teamDescription2: string;
  team2: string;
  date: number;
  matchSeries: string;
  indefinitelyRescheduled: boolean;
  delayPossible: boolean;
  mode: string;
}

interface MatchSeries {
  class: string;
  id: string;
  name: string;
  shortName: string;
  orderLevel: number;
  gender: "FEMALE" | "MALE";
  matches: string[];
  teams: Team[];
}

interface Team {
  id: string;
  name: string;
  shortName: string;
  clubCode: string;
  letter: string;
  logoImage200: string;
}
